<script setup>
import {
  onMounted, onUnmounted, ref, watch,
} from 'vue';
import Select2Cifra from '../Select2Cifra';

const props = defineProps({
  modelValue: { type: [String, Number, Array], default: undefined },
  // Es la lista de opciones del selector, los datos en sí
  options: { type: [Array, Object, Promise], default: undefined },
  // Settings para asignar a select2
  settings: { type: Object, default() { return { language: this.$I18n.currentLocale() }; } },

});

const emits = defineEmits(['update:modelValue']);
const input = ref();

function inicializarSelect2(select2Cifra) {
  select2Cifra.$select2
    .val(props.modelValue)
    .trigger('change')
    .on('change', () => {
      emits('update:modelValue', select2Cifra.$select2.val());
    });
}

function createSelect2() {
  const select2Cifra = new Select2Cifra(
    input.value,
    { data: props.options, ...props.settings },
    {
      onConnect: inicializarSelect2,
    });
  select2Cifra.connect();
  return select2Cifra;
}

let select2Cifra;

onMounted(() => {
  select2Cifra = createSelect2();
});

onUnmounted(() => {
  select2Cifra.disconnect();
});

watch(() => props.modelValue, (value) => {
  select2Cifra.$select2.val(value).trigger('change');
});

watch(() => props.options, (value) => {
  select2Cifra.setOptions(value);
});

// Devuelve un array con los objetos seleccionados. Dentro de estos
// objetos hay más información como por ejemplo los data
function selectedData() {
  return select2Cifra.$select2.select2('data');
}

defineExpose({ selectedData });

</script>

<template>
  <select ref="input">
    <slot></slot>
  </select>
</template>
